export default [{
    path: '/admin/device/bracelet',
    name: 'Bracelet',
    component: () => import('../views/device/bracelet'),
    meta: {
      title: '手环'
    }
  },
  {
    path: '/admin/device/watch',
    name: 'Watch',
    component: () => import('../views/device/watch'),
    meta: {
      title: '手表'
    }
  },
  {
    path: '/admin/device/xueyaoji',
    name: 'xueyaoji',
    component: () => import('../views/device/xueyaji'),
    meta: {
      title: '血压计'
    }
  },
  {
    path: '/admin/device/xuetangyi',
    name: 'xuetangyi',
    component: () => import('../views/device/xuetangyi'),
    meta: {
      title: '血糖仪'
    }
  },
  {
    path: '/admin/monitoring/list',
    name: 'monitoringList',
    component: () => import('../views/device/monitoring/list'),
    meta: {
      title: '设备-监控列表'
    }
  },
  {
    path: '/admin/monitoring/type',
    name: 'monitoringType',
    component: () => import('../views/device/monitoring/type'),
    meta: {
      title: '设备-监控分类'
    }
  },
  {
    path: '/admin/cloudAuth/cloudAuth',
    name: 'cloudAuth',
    component: () => import('../views/device/cloudAuth/cloudAuth'),
    meta: {
      title: '设备-云端授权'
    }
  },
  {
    path: '/admin/device/bodyFatScale',
    name: 'bodyFatScale',
    component: () => import('../views/device/bodyFatScale'),
    meta: {
      title: '设备-体脂秤'
    }
  },
  {
    path: '/admin/device/list',
    name: 'DeviceList',
    component: () => import('../views/device/device_list'),
    meta: {
      title: '设备-设备列表',
      keepAlive: true,
    }
  },
  {
    path: '/admin/device/alarm_list',
    name: 'DeviceAlarmList',
    component: () => import('../views/device/alarm/list'),
    meta: {
      title: '设备-报警记录'
    }
  },
  {
    path: '/admin/device/detail',
    name: 'DeviceDetail',
    component: () => import('../views/device/device_dtl'),
    meta: {
      title: '设备-详情信息'
    }
  },
  {
    path: '/admin/device/device_map',
    name: 'DeviceMap',
    component: () => import('../views/device/device_map'),
    meta: {
      title: '设备-设备地图'
    }
  },
  {
    path: '/admin/device/authority/account_number',
    name: 'AuthorityAccountNumber',
    component: () => import('../views/device/authority/account_number'),
    meta: {
      title: '权限-账号管理'
    }
  },
  {
    path: '/admin/device/authority/role',
    name: 'AuthorityRole',
    component: () => import('../views/device/authority/role'),
    meta: {
      title: '权限-角色管理'
    }
  },
  {
    path: '/admin/device/authority/organization',
    name: 'AuthorityOrganization',
    component: () => import('../views/device/authority/organization'),
    meta: {
      title: '机构管理-机构列表'
    }
  },
  {
    path: '/admin/device/authority/service_set',
    name: 'ServiceSet',
    component: () => import('../views/device/authority/service_set'),
    meta: {
      title: '服务商设置'
    }
  },
  {
    path: '/admin/device/authority/service_examine',
    name: 'ServiceExamine',
    component: () => import('../views/device/authority/service_examine'),
    meta: {
      title: '服务商审核'
    }
  },
  {
    path: '/admin/device/medicineChest/Index',
    name: 'MedicineChestIndex',
    component: () => import('../views/device/medicineChest/index'),
    meta: {
      title: '设备-商品管理'
    }
  },
  {
    path: '/admin/device/data_large_screen',
    name: 'DeviceDataLargeScreen',
    component: () => import('../views/device/data_large_screen'),
    meta: {
      title: '设备-数据大屏'
    }
  },
  {
    path: '/admin/device/mqtt/realTimeData',
    name: 'DeviceMqttRealTimeData',
    component: () => import('../views/device/mqtt/realTimeData'),
    meta: {
      title: '设备-实时数据'
    }
  },
  {
    path: '/admin/device/mqtt/statement',
    name: 'DeviceMqttStatement',
    component: () => import('../views/device/mqtt/statement'),
    meta: {
      title: '设备-数据报告'
    }
  },
  {
    path: '/admin/device/aotong/list',
    name: 'DeviceAotongList',
    component: () => import('../views/device/aotong/list'),
    meta: {
      title: '跌倒报警器'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/device.js